<template>
	<div>
		<h2 class="text-subtitle">Update Password</h2>

		<ux-form ref="form">
			<ux-text-field
				type="password"
				label="Old Password"
				:rules="rules.old_password"
				v-model="form.old_password"
			/>

			<ux-text-field
				type="password"
				label="New Password"
				:rules="rules.password"
				v-model="form.password"
			/>

			<ux-text-field
				type="password"
				label="Confirm Password"
				:rules="rules.password_confirmation"
				v-model="form.password_confirmation"
			/>
		</ux-form>

		<ul class="ux-btn-list is-horz-end">
			<li><ux-btn color="outline-primary" :loading="saving" @click="save">Update Password</ux-btn></li>
		</ul>
	</div>
</template>

<script>
import api from 'frontend/api';
import validate from 'common/validators';
import alerts from 'common/alerts';

export default {
	data()
	{
		return {
			saving: false,

			form: {
				old_password: '',
				password: '',
				password_confirmation: '',
			},
			
			rules: {
				old_password: [ v => !!v || 'Please enter your old password' ],
				password: [ 
					v => !!v || 'Please enter your new password',
					v => validate.password(v) || 'Passwords must be six characters or longer'
				],
				password_confirmation: [
					v => !!v || 'Please re-enter your new password',
					v => v == this.form.password || 'Passwords do not match!',
				]
			}
		}
	},

	methods: {
		async save()
		{
			if (!this.$refs.form.validate())
				return;

			this.saving = true;

			try
			{
				await api.post('/profile/update_password', this.form);
				await alerts.show('Password updated successfully!', 'Success', 'success');
				
				this.form = { 
					old_password: '',
					password: '',
					password_confirmation: '',
				};
			}
			finally
			{
				this.saving = false;
			}
		}
	}
}
</script>